import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
// import { FiBook } from "react-icons/fi";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";

const StyledHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
  paddingRight: "10px",
}));

const StyledCategoriesIcon = styled(MeetingRoomIcon)(({ theme }) => ({
  marginLeft: 16,
  fontSize: 24,
  color: theme.palette.primary.main,
  "&:hover": {
    cursor: "pointer",
  },
}));

const EventSpacesHeader = () => {
  return (
    <StyledHeader>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Typography
          ml={2}
          variant="h1"
          fontWeight={700}
          fontSize={26}
          sx={{ alignSelf: "flex-end" }}
          color="primary.main"
        >
          Event Space Category
        </Typography>
        <StyledCategoriesIcon />
      </Box>
    </StyledHeader>
  );
};

export default EventSpacesHeader;
